import { FeedBackForm, Modal } from '@/components'
import { StyledButton } from '@/components/styles'
import { useTranslation } from "react-i18next";

const Trigger = props => {
  const { t } = useTranslation("global");
  return <StyledButton {...props}>{t('leaveFeedback')}</StyledButton>
}

export default function FeedBack({ render: TriggerView = Trigger }) {
  return (
    <Modal render={TriggerView} view="appointment">
      <FeedBackForm />
    </Modal>
  )
}
